"use strict";

exports.__esModule = true;
exports.resolveDefaultValue = resolveDefaultValue;
var _conversionUtils = require("../../manifest-mappers/conversion-utils");
var _variants = require("../../types/metadata/variants");
function resolveDefaultValue({
  metadata,
  params,
  isMobile = false,
  t
}) {
  const resolvedMetadata = resolveMetadata(metadata, t);
  const resolvedParams = Object.fromEntries(Object.entries(params).map(([key, value]) => [key, {
    metadata: value.metadata ? resolveMetadata(value.metadata, t) : undefined
  }]));
  const item = (0, _conversionUtils.mapParamToItem)({
    metadata: resolvedMetadata,
    params: resolvedParams,
    isMobile,
    validate: type => type in _variants.StyleType || type in _variants.DataType,
    createItem: (itemType, defaultValue) => {
      return isStyleType(itemType) ? {
        cssPropertyType: itemType,
        defaultValue
      } : {
        dataType: itemType,
        defaultValue
      };
    }
  });
  if (isStyleType(resolvedMetadata.type)) {
    const styleItem = item && 'cssPropertyType' in item ? item : undefined;
    return {
      type: resolvedMetadata.type,
      defaultValue: styleItem == null ? void 0 : styleItem.defaultValue
    };
  }
  if (isDataType(resolvedMetadata.type)) {
    const dataItem = item && 'dataType' in item ? item : undefined;
    return {
      type: resolvedMetadata.type,
      defaultValue: dataItem == null ? void 0 : dataItem.defaultValue
    };
  }
  throw new Error('Invalid item type received');
}
const resolveMetadata = (metadata, t) => typeof metadata === 'function' ? metadata({
  t
}) : metadata;
const isStyleType = type => type in _variants.StyleType;
const isDataType = type => type in _variants.DataType;
//# sourceMappingURL=resolve-default-values.js.map